import { Dispatch } from '@reduxjs/toolkit';
import { AnyAction } from 'redux-saga';
import { zooluxCallCenterAPI } from '../../../zooluxCallCenterAPI';

const userAPI = zooluxCallCenterAPI.injectEndpoints({
    endpoints: (builder) => ({
        archiveUserAdmin: builder.mutation<any, any>({
            query: (user_ids) => {
                return {
                    url: '/admin/user/archive',
                    method: 'PUT',
                    body: user_ids
                };
            },
            async onQueryStarted(_, { dispatch, queryFulfilled }: {
                dispatch: Dispatch<AnyAction>,
                queryFulfilled: Promise<{ data: any; }>,
            }) {
                try { } catch (error) {
                    console.error("Error fetching archiveUserAdmin:", error);
                }
            },
            invalidatesTags: ["UserAdmin"]
        }),
    }),
    overrideExisting: false,
});

export const { useArchiveUserAdminMutation } = userAPI;
